import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';
import { useSelectedPharmacyId } from 'app/hooks';

interface OrderStatusCountsResponse {
  new: number;
  pending: number;
}

async function getOrderStatusCounts(pharmacyId: string): Promise<OrderStatusCountsResponse> {
  const queryParams = new URLSearchParams({ pharmacyId });
  const response = await axiosPrivate.get<OrderStatusCountsResponse>(
    `/v3/pharmacist/orders/counts?${queryParams.toString()}`
  );
  return response.data;
}

export const ORDER_STATUS_COUNT_QUERY_KEY = 'pharmacy-orders-count';

export default function useOrderStatusCounts() {
  const selectedPharmacyId = useSelectedPharmacyId();

  const { data } = useQuery({
    queryKey: [ORDER_STATUS_COUNT_QUERY_KEY, selectedPharmacyId],
    queryFn: () => getOrderStatusCounts(selectedPharmacyId!),
    enabled: !!selectedPharmacyId,
    meta: { errorMessage: 'Failed to fetch order status counts' },
  });

  return {
    newCount: data?.new ?? 0,
    pendingCount: data?.pending ?? 0,
  };
}
